import React from 'react';

export default function () {
  return {
    location: {},
    object: {},
    publication: {}
  };
}
